<template>
	<b-container>
		<b-row>
			<b-col cols="12">
				<transition name="slide">
					<!--<b-card no-body>
						<div slot="header" class="d-flex justify-content-between custom-card-header">
							<h5 class="card-header-title">{{ $t('pos.title') }}</h5>

							<div class="card-header-actions">
								<div class="searchInCard">
									<b-input-group size="sm">
										<b-form-input v-model="filter"
													  size="sm"
													  autocomplete="off"
													  :placeholder="$t('contragent.search')"
										>
										</b-form-input>
										<b-input-group-append>
											<b-button
												:disabled="!filter"
												@click="filter = ''"
											>{{ $t('contragent.clear') }}</b-button>
										</b-input-group-append>
									</b-input-group>
								</div>
								<b-link
									@click="showCreatePosModal()"
									size="sm" variant="primary"
								>
									<i class="fa fa-plus-circle"
									   style="font-size: 1.4em; color: #53575B; margin-right: 3px;"
									></i>
								</b-link>
							</div>
						</div>
					</b-card>-->
					<base-card-with-table
						@create="createPos()"
						@filterChanged="filterChanged"
						@clearFilter="filter=''"
						:headerTitle="$t('pos.title')"
						:filter="filter"
					>
						<template v-slot:table>
							<b-table
								class="generalTableClass table-responsive"
								:filter="filter"
								:hover="true" :striped="true" :bordered="true"
								:small="true"
								responsive="sm"
								:items="posList"
								:fields="fieldsForPos"
							>
								<!-- EMPTY SLOT FOR TABLE -->
								<template slot="empty" slot-scope="scope">
									<h4>{{ $t('empty') }}</h4>
								</template>
								<!-- EMPTY SLOT FOR TABLE -->
							</b-table>
						</template>
					</base-card-with-table>
				</transition>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	import BaseCardWithTable from '../../components/base-card-with-table'

	export default {
		name: "PosList",
		components: {
			BaseCardWithTable
		},
		data() {
			return {
				filter: '',
				posList: [
					{
						id: 0,
						fullName: 'Shim',
						shortName: 'Shim'
					},
					{
						id: 1,
						fullName: 'Ko\'ylak',
						shortName: 'Ko\'ylak'
					},
					{
						id: 2,
						fullName: 'Kurtka',
						shortName: 'Kurtka'
					},
					{
						id: 3,
						fullName: 'Shapka',
						shortName: 'Shapka'
					},
				],
				fieldsForPos: [
					{
						key: 'id',
						label: 'Id',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'fullName',
						label: this.$t('contragent.full-name'),
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'shortName',
						label: this.$t('contragent.short-name'),
						sortable: true,
						visible: false,
						changebale: true
					},
				]
			}
		},
		methods: {
			createPos() {
			},
			filterChanged(newVal) {
				this.filter = newVal;
			}
		}
	}
</script>

<style scoped>

</style>
